import { FC } from 'react'
import { StyleSheet } from 'react-native'
import { Dialog, IconButton, Portal, Text } from 'react-native-paper'
import { ColorsEnum } from '../../../constants/colors'
import { FontsEnum } from '../../../constants/fonts'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'
import { appSelectors, clearCustomerInfoDialog } from '../../../redux/reducers/app'
import { performHaptics } from '../../../utils/performHaptics'
import OrderColorMenu from './OrderColorMenu'

const CustomerInfoDialog: FC = () => {
    const customerInfoDialog = useAppSelector(appSelectors.customerInfoDialog)

    const dispatch = useAppDispatch()

    if (!customerInfoDialog.orderKey) {
        return null
    }

    const handleDismiss = () => {
        dispatch(clearCustomerInfoDialog())
    }

    const handleClose = () => {
        performHaptics()

        dispatch(clearCustomerInfoDialog())
    }

    return (
        <Portal>
            <Dialog
                visible={customerInfoDialog.visible}
                onDismiss={handleDismiss}
                style={styles.dialog}
            >
                <OrderColorMenu orderKey={customerInfoDialog.orderKey} />
                <IconButton
                    icon="close-circle-outline"
                    iconColor="#000000"
                    size={44}
                    onPress={handleClose}
                    style={styles.button}
                />
                <Dialog.Title style={styles.title}>{customerInfoDialog.orderCode}</Dialog.Title>
                <Dialog.Content>
                    <Text style={styles.text}>{customerInfoDialog.customerName}</Text>
                    {!!customerInfoDialog.customerPhone && (
                        <Text style={styles.text}>{customerInfoDialog.customerPhone}</Text>
                    )}
                    {!!customerInfoDialog.customerAddress && (
                        <Text style={styles.text}>{customerInfoDialog.customerAddress}</Text>
                    )}
                </Dialog.Content>
            </Dialog>
        </Portal>
    )
}

const styles = StyleSheet.create({
    dialog: {
        alignSelf: 'center',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        width: 400,
    },
    title: {
        fontFamily: FontsEnum.RUBIK_500_MEDIUM,
        color: ColorsEnum.SUCCESS,
        fontSize: 32,
        paddingTop: 48,
    },
    text: {
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
        fontSize: 19,
        textAlign: 'center',
        marginTop: 4,
    },
    button: {
        position: 'absolute',
        top: -12,
        right: 0,
    },
})

export default CustomerInfoDialog
